












































import { Component, Vue, Watch } from 'vue-property-decorator'
import PublicTable from '@/components/PublicTable/PublicTable.vue'
import PublicTableView from '@/components/PublicTable/PublicTableView'
import { ICol } from '@/components/PublicTable/PublicTable'
import PublicQuery from '@/components/PublicQuery/PublicQuery.vue'
import { IFormItem } from '@/components/PublicQuery/PublicQuery'
import SelectRegion from '@/components/Select/SelectRegion.vue'
import SelectDepartment from '@/components/Select/SelectDepartment.vue'
import api from '../../api'
import { UserModule } from '../../store/modules/user'
import config from '@/config'
import md5 from 'js-md5'

@Component({
  components: {
    PublicTable,
    PublicQuery,
    SelectRegion,
    SelectDepartment,
  },
})
export default class StatsTable extends PublicTableView {
  protected queryItems: IFormItem[] = [
    {
      label: '选择日期',
      key: 'date',
      type: 'date',
      dateType: 'daterange',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
    },
  ]
  protected queryParams = {
    date: '',
    region: [],
    level: 0,
  }
  
  protected columns: ICol[] = [
    { label: '序号', prop: 'index', fixed: true, width: 80 },
    { label: '设备名称', prop: 'devName', fixed: true, minWidth: 150,width: 'auto' },
    { label: '设备MAC', prop: 'devId', fixed: true, minWidth: 150, width: 'auto' }
    // 日期列将在processData方法中动态添加
  ]
  
  @Watch('queryParams.level')
  private watchLevel() {
    this.queryParams.region = []
  }
  
  private handleSearch() {
    const { date = [], region = [], level = 0 } = this.queryParams || {}
    if (!region || !region.length) {
      this.$message.warning('请选择查询网络')
      return
    }
    if (!date || !date.length) {
      this.$message.warning('请选择日期')
      return
    }
    this.onQuery(1)
  }
  
  // 导出功能
  private handleExport1() {
    const { date = [], region = [], level = 0 } = this.queryParams || {}
    if (!region || !region.length) {
      this.$message.warning('请选择查询网络')
      return
    }
    if (!date || !date.length) {
      this.$message.warning('请选择日期')
      return
    }
    
    // 构造导出参数
    const exportParams = this.getExportParams(this.queryParams)
    
    // 显示导出提示
    this.$message.info('正在导出数据，请稍候...')
    
    // 调用导出接口
    api.exportSwitchTable(exportParams).then((response) => {
      // 确保response.data存在
      if (!response || !response.data) {
        this.$message.error('导出数据为空')
        return
      }
      
      // 处理文件下载
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      
      // 获取响应头中的文件名
      let filename = '空开数据表格.xlsx'
      if (response.headers) {
        const disposition = response.headers['content-disposition'] || response.headers['Content-Disposition']
        if (disposition && disposition.indexOf('attachment') !== -1) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          const matches = filenameRegex.exec(disposition)
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '')
          }
        }
      }
      
      // 创建下载链接
      if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
        // 兼容IE浏览器
        (window.navigator as any).msSaveOrOpenBlob(blob, filename)
      } else {
        // 其他浏览器
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
      
      this.$message.success('导出成功')
    }).catch((error) => {
      console.error('导出失败:', error)
      this.$message.error('导出失败: ' + (error.message || '未知错误'))
    })
  }

    private handleExport() {
      const { date = [], region = [], level = 0 } = this.queryParams || {}
    if (!region || !region.length) {
      this.$message.warning('请选择查询网络')
      return
    }
    if (!date || !date.length) {
      this.$message.warning('请选择日期')
      return
    }
    
    // 构造导出参数
    const exportParams = this.getExportParams(this.queryParams)
      const timeStamp = Date.now()
    console.log(UserModule.orgInfo.orgId)
    let params = {
      orgId: UserModule.orgInfo.orgId,
    }

    this.$confirm("是否需要导出数据明细?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        fetch(config.apiBaseUrl+"/V1/Electric/ElectricTableExport",{
  method: 'POST',
  body: JSON.stringify(exportParams),
  responseType: 'blob',
  headers: {

    'Content-Type': 'application/json',
    

   

     'Name': UserModule.name,
        'Token': UserModule.token,
        'Time-Stamp': timeStamp,
        'platform': 'manageWeb',
        'Sign': md5(`${UserModule.name}${UserModule.token}${timeStamp}${UserModule.staticKey}`),
  }
})
.then(response =>response.blob()
)
.then(data => {
  console.log(data);
  
  let downloadFilename = '数据明细.xls'//设置导出的文件名
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //兼容ie浏览器  
    window.navigator.msSaveOrOpenBlob(data, downloadFilename)
  } else {
    //谷歌,火狐等浏览器
    let url = window.URL.createObjectURL(data)
    let downloadElement = document.createElement("a")
    downloadElement.style.display = "none"
    downloadElement.href = url
    downloadElement.charset = 'UTF-8'
    downloadElement.download = downloadFilename
    document.body.appendChild(downloadElement)
    downloadElement.click()
    document.body.removeChild(downloadElement)
    window.URL.revokeObjectURL(url)
  }
})
.catch(error => console.error('Error:', error));





        // window.location.href = "https://api.szh1tech.com/V1/Org/orgExcel?orgId="+UserModule.orgInfo.orgId
      //   api.orgExcel({orgId:UserModule.orgInfo.orgId}).then(response=>{
      //   // Axios({
      //   //   method: "get",
      //   //   url: "/V1/Org/orgExcel",
      //   //   baseURL: "http://47.115.57.107:8087/",
      //   //   params: params,
      //   //   // responseType: "blob", //定义接口响应的格式,很重要
      //   // }).then((response) => {
      //     console.log(response);
          
      //     let blob = new Blob([response], { type:'application/octet-stream' }) //response.data为后端传的流文件
      //     // console.log(bolb)
          
      //     let downloadFilename ='关系列表.xls'//设置导出的文件名
      //     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //       //兼容ie浏览器
      //       window.navigator.msSaveOrOpenBlob(blob, downloadFilename)
      //     } else {
      //       //谷歌,火狐等浏览器
      //       let url = window.URL.createObjectURL(blob,{type : 'application/vnd.ms-excel;charset=utf-8'})
      //       let downloadElement = document.createElement("a")
      //       downloadElement.style.display = "none"
      //       downloadElement.href = url
      //       downloadElement.charset = 'UTF-8'
      //       downloadElement.download = downloadFilename
      //       document.body.appendChild(downloadElement)
      //       downloadElement.click()
      //       document.body.removeChild(downloadElement)
      //       window.URL.revokeObjectURL(url)
      //     }
      //   })
      })
      .catch(() => {})
  }
  
  private queryChange() {
  }
  
  protected queryMethod = api.getSwitchTable
  
  protected getQueryParams(params: any) {
    const { date = [], region = [], level = 0 } = params || {}
    // 构造netIdGroupIdList参数
    console.log('123',region);
    
    // const netIdGroupIdList = region.map((netId: string) => ({
    //   netId: netId[3],
    //   groupId: ["49152"] // 默认groupId，可根据实际需求调整
    // }))
    const netIdGroupIdList = region.map((netId: string) => ({
      netId: netId[3],
      groupId: netId[4] ? [netId[4]] : ["49152"] // 默认groupId，可根据实际需求调整
    }))
    
    return {
      start: date[0],
      end: date[1],
      netIdGroupIdList
    }
  }
  
  // 导出参数构造方法
  protected getExportParams(params: any) {
    return this.getQueryParams(params)
  }
  
  protected processData(payload: any[]) {
    if (Array.isArray(payload) && payload.length > 0) {
      // 为每行数据添加序号
      const payloadWithIndex = payload.map((item, index) => {
        return {
          ...item,
          index: index + 1
        }
      })
      
      // 获取所有日期字段（除了index, devId和devName）
      const dateFields: string[] = []
      const firstItem = payloadWithIndex[0]
      
      // 遍历第一个对象的所有属性，找出日期字段
      for (const key in firstItem) {
        if (key !== 'index' && key !== 'devId' && key !== 'devName') {
          dateFields.push(key)
        }
      }
      
      // 对日期字段进行排序
      dateFields.sort((a, b) => {
        // 将日期字符串转换为Date对象进行比较
        return new Date(a).getTime() - new Date(b).getTime()
      })
      
      // 动态生成表头列
      const dynamicColumns: ICol[] = [
        { label: '序号', prop: 'index', fixed: true, width: 80 },
        { label: '设备名称', prop: 'devName', fixed: true,  minWidth: 200, width: 'auto'},
        { label: '设备MAC', prop: 'devId', fixed: true, minWidth: 150, width: 'auto' }
      ]
      
      // 添加排序后的日期列（不固定，自动宽度）
      dateFields.forEach(date => {
        dynamicColumns.push({ label: date, prop: date, minWidth: 120 })
      })
      
      // 更新列定义
      this.columns = dynamicColumns
      
      // 返回处理后的数据
      return payloadWithIndex
    } else {
      // 如果没有数据，保持基本列定义（包含序号列）
      this.columns = [
        { label: '序号', prop: 'index', fixed: true, width: 80 },
        { label: '设备名称', prop: 'devName', fixed: true, width: 120 },
        { label: '设备ID', prop: 'devId', fixed: true, minWidth: 150, width: 'auto' }
      ]
      return []
    }
  }
}
